/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LayoutFieldsResponseDto } from '../../models/layout-fields-response-dto';

export interface ClientGetLayoutFieldsGet$Plain$Params {
  layout_uuid?: string;
}

export function clientGetLayoutFieldsGet$Plain(http: HttpClient, rootUrl: string, params?: ClientGetLayoutFieldsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LayoutFieldsResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, clientGetLayoutFieldsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('layout_uuid', params.layout_uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LayoutFieldsResponseDto>>;
    })
  );
}

clientGetLayoutFieldsGet$Plain.PATH = '/Client/GetLayoutFields';
